import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import Home from "./pages/Home";
import WhoWeAre from "./pages/WhoWeAre";
import WhatWeDo from "./pages/WhatWeDo";
import WhereWeWork from "./pages/WhereWeWork";
import NewsAndMedia from "./pages/NewsAndMedia";
import YearInReview from "./pages/YearInReview";
import Insights from "./pages/Insights";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./styles/variables.css";
import "./styles/globals.scss";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ScrollToTop from "./helpers/ScrollToTop";
import NewsArticle from "./pages/articles/NewsArticle";
import LinkDisclaimer from "./components/LinkDisclaimer";
import DisclaimerContext from "./utils/DisclaimerContext";
import PageContext from "./utils/PageContext";
import MeasuringImpact from "./pages/MeasuringImpact";

function App() {
  // ReactGA.initialize('G-6M5LBH530R');
  // ReactGA.send('pageview');

  const [currentPage, setCurrentPage] = useState("/");
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disclaimerLink, setDisclaimerLink] = useState("");

  useEffect(() => {
    // Load the OneTrust cookie script
    const otScript = document.createElement("script");
    otScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    otScript.type = "text/javascript";
    otScript.charset = "UTF-8";
    otScript.setAttribute("data-domain-script", "019135bb-abf7-7f51-b21f-fc87ff47e306");
    //staging cookie id
    // otScript.setAttribute("data-domain-script", "019159d2-145d-743f-b26e-e2f4456c7167-test");
    document.body.appendChild(otScript);

    // OptanonWrapper function to be triggered by the script
    window.OptanonWrapper = function () {
      var cookieDomain = ".saferchildbirthsystems.com";
      // staging cookie domain
      // var cookieDomain = ".clientcenter.com";
      var consentLevels = getConsentLevels();
      console.log(
        "C0001:" +
          consentLevels[1] +
          "  C0002:" +
          consentLevels[2] +
          "  C0003:" +
          consentLevels[3] +
          "  C0004:" +
          consentLevels[4] +
          "  C0005:" +
          consentLevels[5],
      );

      if (consentLevels[3]) {
        ReactGA.initialize("G-6M5LBH530R");
        ReactGA.send("pageview");
      }

      if (!consentLevels[3]) {
        expireCookie("_ga");
        expireCookie("_gid");
        expireCookie("_ga_6M5LBH530R");
        expireCookie("_ga_NGFPQWHXVB");
        expireCookie("_ga_RT93JWJTEJ");
      }

      if (!consentLevels[4]) {
      }

      if (!consentLevels[5]) {
      }

      window.GlobalConsentLevels = consentLevels;

      function getConsentLevels() {
        var stringCookie = getCookie("OptanonConsent");
        console.log(stringCookie);
        var consentLevels = new Array();
        consentLevels[1] = stringCookie.charAt(stringCookie.search("C0001:") + 6) == "1" ? true : false;
        consentLevels[2] = stringCookie.charAt(stringCookie.search("C0002:") + 6) == "1" ? true : false;
        consentLevels[3] = stringCookie.charAt(stringCookie.search("C0003:") + 6) == "1" ? true : false;
        consentLevels[4] = stringCookie.charAt(stringCookie.search("C0004:") + 6) == "1" ? true : false;
        consentLevels[5] = stringCookie.charAt(stringCookie.search("C0005:") + 6) == "1" ? true : false;
        return consentLevels;
      }

      function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      function expireCookie(cname) {
        var d = new Date();
        d.setTime(d.getTime());
        var expires = " expires=" + d.toUTCString();
        document.cookie = cname + "=;" + expires + "; domain=" + cookieDomain + "; path=/";
      }
    };

    return () => {
      document.body.removeChild(otScript);
    };
  }, []);

  return (
    <div className="app">
      <PageContext.Provider value={{ currentPage, setCurrentPage }}>
        <DisclaimerContext.Provider
          value={{
            showDisclaimer,
            setShowDisclaimer,
            disclaimerLink,
            setDisclaimerLink,
          }}
        >
          <Navbar />
          <LinkDisclaimer />
          <ScrollToTop>
            <Routes>
              <Route path="/" index element={<Home />} />
              <Route path="/who-we-are" element={<WhoWeAre />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/where-we-work" element={<WhereWeWork />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/learn-more" element={<NewsAndMedia />} />
              <Route path="/kicking-off-2025" element={<YearInReview />} />
              <Route path="/measuring-impact-across-the-coalitions" element={<MeasuringImpact />} />
              <Route path="/learn-more/lorem-ipsum-dolor-sit-amet" element={<NewsArticle />} />
            </Routes>
          </ScrollToTop>
          <Footer />
        </DisclaimerContext.Provider>
      </PageContext.Provider>
    </div>
  );
}

export default App;
